import { videoViews3SecConfig } from '../videoViews3Sec';
import { SIZE_50 } from '@/lib/gridElements/size';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const videoViews3SecMVConfig = {
    ...videoViews3SecConfig,
    tooltip: false,
    name: 'kpi.facebook.video_views_3_sec',
    id: 'video_views',
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
